<template lang="pug">
  md-dialog(:md-active.sync="showDialog" v-on:md-closed="clearForm")
    md-dialog-title Request to join {{groupName}} Fund
    .md-layout
      .md-layout-item.md-size-100
        p(v-if="error" style="color: red") Sorry, there was an error fulfilling this request. Please try again later.
      .md-layout-item.md-size-100
        span(style="margin-right: 15px;") Have you taken a semester of Anaylst Group?
        md-checkbox(v-model="agTaken" :true-value="true" :false-value="false")
      .md-layout-item.md-size-100(style="margin-top: 10px;")
        p If yes, who were your analyst group leaders?
        md-field
          md-input(v-model='saNames' type='text')
    md-dialog-actions
      md-button.md-raised(@click="showDialog = false") Cancel
      md-button.md-raised.md-success(@click="requestJoin()") Request to Join
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      saNames: '',
      saNamesOG: '',
      agTaken: false,
      groupName: null,
      groupID: null,
      showDialog: null,
      error: null,
    }
  },
  created() {
    this.$bus.$on('fundRequest:open', (group) => {
      this.openDialog(group);
    });
  },
  methods: {
    requestJoin() {
      var formData = new FormData();
      formData.append('ag_taken', this.agTaken);
      formData.append('sa_names', this.saNames);
      axios.post(`/api/org/funds/${this.groupID}/request_join`, formData)
      .then((res) => {
        this.$bus.$emit('fundRequest:success');
        this.showDialog = false;
      }).catch((err) => {
        this.error = true;
      })
    },
    clearForm() {
      this.saNames = this.saNamesOG;
      this.agTaken = null;
      this.groupName = null;
      this.groupID = null;
    },
    openDialog(group) {
      if(this.$store.state.user.analyst_group) {
        axios.get(`/api/org/analyst_groups/${this.$store.state.user.analyst_group}`)
        .then((res) => {
          this.saNamesOG = res.data.senior_analysts
          this.saNames = this.saNamesOG;
        })
      }
      this.groupName = group.name;
      this.groupID = group.fund_id;
      this.showDialog = true;
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/pages/Fund/FundRegisterForm.vue